import React from "react";
import { Flex, Box, Container } from "@chakra-ui/react";
import HolidaysList from "./components/HolidaysList";

const Holidays = () => {

  return (
   <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
<HolidaysList />      
      </Container>
  );
};

export default Holidays;
